import sortBy from 'lodash/sortBy';

import { Service } from 'common/src/types/enums/Service.enum';
import { IFacility } from 'common/src/types/interfaces';

import {
  autoCompleteType,
  datePickerType,
  numberType,
  selectInputType,
  textInputType,
} from 'portal/src/components/common/forms/FormFieldTypes';

export interface AccesibilityForm {
  isCopy: boolean;
  importPriorFiscalYear: boolean;
}

export function getBudgetInformationFields(
  { isCopy = false, importPriorFiscalYear = false }: AccesibilityForm,
  importFiscalYears: number[] = [],
): Array<datePickerType | numberType | selectInputType | textInputType> {
  const fields = [
    {
      label: 'Name',
      name: 'name',
      type: 'textInputType',
      required: true,
      placeholder: 'Name',
    },
    {
      other: {
        views: ['year'],
        openTo: 'year',
      },
      label: 'Budget Fiscal Year',
      placeholder: 'Budget Fiscal Year',
      name: 'fiscalYear',
      type: 'datePicker',
      required: true,
    },
  ] as Array<datePickerType | numberType | selectInputType>;

  if (importPriorFiscalYear)
    fields.push({
      label: 'Prior Fiscal Year',
      multiple: true,
      name: 'importFiscalYears',
      placeholder: 'Prior Fiscal Year',
      required: true,
      type: 'selectInput',
      values: importFiscalYears.map((value) => ({
        label: String(value),
        value: value,
      })),
    });

  if (isCopy || importPriorFiscalYear)
    fields.push({
      adorment: '% ',
      label: 'Adjustment %',
      name: 'adjustment',
      placeholder: 'Adjustment %',
      required: false,
      infoTooltip:
        'This will copy the entire budget for all facilities and service types from the selected fiscal year. The adjustment factor increases all elements of the budget by the selected percentage. Selecting 0% for the adjustment factor will cope the previous budget without making any adjustment.',
      type: 'number',
    });

  return fields;
}

export function getBudgetCopyDetailsFields(
  importPriorFiscalYear: boolean,
  facilities: IFacility[],
): Array<autoCompleteType | selectInputType> {
  const fields = [];

  if (importPriorFiscalYear) {
    fields.push({
      label: 'Facilities for Fiscal Year',
      multiple: true,
      name: 'facilities',
      options: sortBy(facilities, (f) => f.name.toLowerCase()).map(
        (facility) => ({
          label: facility.name,
          value: facility.id,
          key: facility.id,
        }),
      ),
      placeholder: 'Facilities for Fiscal Year',
      required: false,
      type: 'autocomplete',
    });

    fields.push({
      label: 'Service Type for Fiscal Year',
      multiple: true,
      name: 'serviceTypes',
      placeholder: 'Service Types for Fiscal Year',
      type: 'selectInput',
      values: Object.values(Service).map((item) => ({
        label: item,
        value: item,
      })),
    });
  }

  return fields;
}
